import { useEffect } from 'react';

const GoogleAdsPopularCollection2Page = ({ adId }) => {
  useEffect(() => {
    if (!window.googletag) {
      window.googletag = { cmd: [] };
    }

    window.googletag.cmd.push(() => {
      const slotName = '/17939840/video_PopularCollectionPage_336_280_pc_2';
      const sizes = [[250, 250], [336, 280], [300, 250], [200, 200]];

      const slotExists = window.googletag
        .pubads()
        .getSlots()
        .some((slot) => slot.getSlotElementId() === adId);

      if (!slotExists) {
        window.googletag.defineSlot(slotName, sizes, adId)
          .addService(window.googletag.pubads());

        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();
      }

      window.googletag.display(adId);
    });
  }, [adId]);

  return (
    <div
      id={adId}
      style={{
        minWidth: '200px',
        minHeight: '200px',
      }}
    ></div>
  );
};

export default GoogleAdsPopularCollection2Page;
